<div class="container gallery-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fas fa-images"></i>
      </div>
      <div class="header-text">
        <h2 class="page-title">Photo Gallery</h2>
        <p class="page-subtitle">Explore our vibrant campus life and memorable moments</p>
      </div>
    </div>
  </div>

  <div class="card modern-card shadow-lg">
    <div class="card-body">
      <div class="card-title">
        <i class="fas fa-camera-retro me-2"></i>
        <span>Gallery Collections</span>
      </div>
      <hr class="title-divider">
      
      <!-- Category Navigation -->
      <div class="category-nav mb-4">
        <div class="category-buttons" role="group" aria-label="Gallery categories">
          <button *ngFor="let category of categories; let i = index" 
                  class="category-btn" 
                  [class.active]="selectedCategory === category"
                  (click)="selectCategory(category)">
            <i class="fas" [ngClass]="getCategoryIcon(i)"></i>
            <span>{{category.name}}</span>
            <span class="badge">{{category.images.length}}</span>
          </button>
        </div>
      </div>

      <!-- Gallery Grid -->
      <div class="gallery-grid-container">
        <div class="row gallery-row">
          <div class="col-lg-3 col-md-4 col-sm-6 mb-4 gallery-col" *ngFor="let image of selectedCategory.images; let i=index">
            <div class="gallery-item" (click)="displayImage(image, i)">
              <div class="image-wrapper">
                <img [src]="image.filename" 
                     [alt]="image.displayText || ''" 
                     class="gallery-image" 
                     loading="lazy">
                <div class="image-overlay">
                  <div class="overlay-content">
                    <i class="fas fa-search-plus zoom-icon"></i>
                    <div class="image-title" *ngIf="image.displayText">{{image.displayText}}</div>
                  </div>
                </div>
                <div class="image-number">{{i + 1}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Image Modal -->
<div class="modal fade" id="galleryModal" tabindex="-1" role="dialog" aria-labelledby="galleryModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div class="modal-content gallery-modal">
      <div class="modal-header">
        <div class="modal-header-content">
          <i class="fas fa-image me-2"></i>
          <h5 class="modal-title" id="galleryModalLabel">{{selectedImage?.displayText || 'Gallery Image'}}</h5>
        </div>
        <button type="button" class="close-btn" data-bs-dismiss="modal" aria-label="Close">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="image-navigation">
          <button class="nav-btn prev-btn" (click)="prevImage()" aria-label="Previous image">
            <i class="fas fa-chevron-left"></i>
          </button>
          
          <div class="modal-image-container">
            <img [src]="selectedImage?.filename" 
                 [alt]="selectedImage?.displayText || ''" 
                 class="modal-image"
                 (load)="onImageLoad($event)">
            <div class="loading-spinner" *ngIf="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>

          <button class="nav-btn next-btn" (click)="nextImage()" aria-label="Next image">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      <div class="modal-footer">
        <div class="footer-info">
          <span class="image-count">
            <i class="fas fa-images me-2"></i>
            Image {{selectedImageIndex + 1}} of {{selectedCategory.images.length}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>